import React from "react";
import loadingGif from "../../../../assets/images/send-reports/loading.gif";

export default function LoadingContainer() {
  return (
    <div id="loading" className="loadingContainerShow">
      <span className="helper" />
      <img className="loadingImg" src={loadingGif} alt="" />
    </div>
  );
}
